import MenuDownloadLink from "@/components/menu/MenuDownloadLink";
import { Box, Paper } from "@mui/material";
import type { JSX } from "react";
import AuthenticationControl from "./AuthenticationControl";
import MenuAdminLink from "./MenuAdminLink";
import { MenuBarShared } from "./MenuBarShared";
import { MenuLinks } from "./MenuLinks";

export type Props = {
  title: string | JSX.Element;
  right?: JSX.Element;
  left?: JSX.Element;
  tabBar?: JSX.Element;
  sx?: any;
  container?: boolean;
  showDownload?: boolean;
  sticky?: boolean;
  imageData?: { gameSystemId?: number; bannerImagePath?: string };
};

export function MenuBar({
  title,
  left,
  right,
  tabBar,
  sx,
  imageData,
  container = false,
  showDownload = false,
  sticky = false
}: Props) {
  const appBar = (
    <MenuBarShared title={title} left={left} tabBar={tabBar} container={container} imageData={imageData}>
      {showDownload && <MenuDownloadLink />}
      <MenuLinks />
      <MenuAdminLink />
      <Box sx={{ whiteSpace: "nowrap" }}>{right ?? <AuthenticationControl />}</Box>
    </MenuBarShared>
  );

  return (
    <Paper
      className="no-print"
      elevation={1}
      square
      sx={{ ...(sticky ? { position: "sticky", top: 0, zIndex: 1100 } : {}), ...sx }}
      style={{ viewTransitionName: "site-header" }}
    >
      {appBar}
    </Paper>
  );
}
